@if ($hideAppShell()) {
  <!-- Maintenance / sign-in error page: render ONLY the router outlet, no app shell -->
  <router-outlet />
} @else {
  <!-- Normal app with full shell -->
  <!-- ERM- 4648 - header has unusally high z-index that causes issues with modals, setting it to 200 -->
  <div class="fixed w-full min-w-full z-[200]">
    @if ($isImpersonating()) {
      <div
        id="impersonation-border"
        class="impersonation-banner"
        [ngClass]="{ 'sticky-impersonate__banner': $isImpersonating() }"
      >
        {{ $impersonationText() }}
        <button
          class="wcg-button"
          outlined="true"
          aria-label="Stop Impersonating"
          color="primary"
          mat-stroked-button
          data-testid="end-impersonation"
          style="background-color: white"
          (click)="endImpersonation()"
        >
          <span class="button-text">Stop Impersonating</span>
        </button>
      </div>
    }

    @if ($isAuthenticated() && !$isMaintenancePage()) {
      <wcg-main-header [impersonateBanner]="$isImpersonating()" />
    }
  </div>
  <div
    class="app-body__container min-w-full"
    [ngClass]="{
      'impersonation-border': $isImpersonating(),
      'pt-96': $isImpersonating(),
      'pt-48': !$isImpersonating(),
    }"
  >
    <div class="body">
      @if ($isAuthenticated()) {
        <div class="hold-banner-container hold-banner-position">
          <holiday-closure />
        </div>
      }
      <wcg-loading />
      <router-outlet />
    </div>
  </div>
}
@if ($showTalkdesk()) {
  <wcg-talkdesk />
}
